// /src/pages/private/members/rosterTools/components/RosterTokenLock.jsx

import React from "react";

export default function RosterTokenLock() {
  return (
    <span className="roster-token-lock" aria-label="Tokens hidden" title="Tokens hidden">
      <svg
        className="roster-token-lock__svg"
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        <path
          fill="currentColor"
          d="M12 17a2 2 0 100-4 2 2 0 000 4zm6-7V9a6 6 0 10-12 0v1H5v12h14V10h-1zm-2 0H8V9a4 4 0 118 0v1z"
        />
      </svg>
    </span>
  );
}
